import { Children, ReactElement } from "react";
import { useI18n } from "src/utils/lni18n";

const ChangedColorLegend = () => {

    const { languageService: t } = useI18n();

    return <ChangedColorLegendWrap>
        <div className="me-3 d-flex">
            <div className="bg-primary me-1">&nbsp;</div> {t.getText("new")}
        </div>

        <div className="me-3 d-flex">
            <div className="bg-warning me-1">&nbsp;</div> {t.getText("changed")}
        </div>

        <div className="me-3 d-flex">
            <div className="bg-primary-danger-mix-vertical me-1">&nbsp;</div> {t.getText("moved")}
        </div>

        <div className="me-3 d-flex">
            <div className="bg-danger me-1">&nbsp;</div> {t.getText("deleted")}
        </div>
    </ChangedColorLegendWrap>
}

export default ChangedColorLegend;

export const ChangedColorLegendWrap = (props: { children?: ReactElement | ReactElement[] }) => {

    return <div className="d-flex flex-wrap mb-3">
        {props.children || <div>&nbsp;</div>}
    </div>
}

export const ChangedColorLegendThreeStates = () => {

    const { languageService: t } = useI18n();

    return <ChangedColorLegendWrap>
        <div className="me-3 d-flex">
            <div className="bg-primary me-1">&nbsp;</div> {t.getText("new")}
        </div>

        <div className="me-3 d-flex">
            <div className="bg-warning me-1">&nbsp;</div> {t.getText("changed")}
        </div>

        <div className="me-3 d-flex">
            <div className="bg-danger me-1">&nbsp;</div> {t.getText("deleted")}
        </div>
    </ChangedColorLegendWrap>
}